"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentTypeElementsBuilder = exports.ContentTypeElementsBuilder = void 0;
const content_type_snippet_elements_builder_1 = require("../content-type-snippets/content-type-snippet-elements.builder");
class ContentTypeElementsBuilder extends content_type_snippet_elements_builder_1.ContentTypeSnippetElements {
    urlSlugElement(element) {
        return element;
    }
    snippetElement(element) {
        return element;
    }
}
exports.ContentTypeElementsBuilder = ContentTypeElementsBuilder;
exports.contentTypeElementsBuilder = new ContentTypeElementsBuilder();
//# sourceMappingURL=content-type-elements.builder.js.map